<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div>
        <div class="section-title">{{ $t("create") }} {{ $t("grn") }}</div>
      </div>
    </div>
    <div class="white-wrapper">
      <form class="row" style="zoom: 0.9">
        <div class="col-md-3 col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                disabled
                v-model="stock_in_details.cine_name"
              />
              <label>{{ $tc("cinema", 1) }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                disabled
                v-model="stock_in_details.v_name"
                v-validate="'required'"
              />
              <label>{{ $tc("vendor") }}</label>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                disabled
                v-model="stock_in_details.po_number"
              />
              <label
                >{{ $t("purchase", 1) }} {{ $t("order") }}
                {{ $t("number") }}</label
              >
            </div>
          </div>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="stock_in_details.po_date"
                  name="stockdate"
                  disabled
                  id="stockdate"
                ></Datepicker>
                <label :class="stock_in_details.po_date ? 'active' : ''"
                  >{{ $t("purchase") }} {{ $t("order") }}
                  {{ $t("date") }}</label
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="dropdown-curve-container">
            <label
              :class="
                storeManagementsLevels &&
                Object.keys(storeManagementsLevels).length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $t("select") }} {{ $tc("store", 1) }}</label
            >
            <b-dropdown
              disabled
              :text="storeManagementsLevels.sm_store_name"
              variant="dropdown-curve"
              class="w-100"
            ></b-dropdown>
          </div>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="stock_in_details.stock_in_date"
                  name="stockdate"
                  disabled
                  id="stockdate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="stock_in_details.stock_in_date ? 'active' : ''"
                  >{{ $t("stock") }} {{ $t("in") }} {{ $t("date") }}</label
                >
              </div>
            </div>
            <!-- <Tooltip :title="$t('stockindate_updatestockin')" />-->
          </div>
          <p v-if="submitted && errors.has('stockdate')" class="error_message">
            {{ errors.first("stockdate") }}
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-2" v-if="false">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="stock_in_details.stock_in_expiry_date"
                  v-on:click="clearSelectedDate1()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="stock_in_details.stock_in_expiry_date"
                  name="expirydate"
                  id="expirydate"
                  typeable
                  v-validate="
                    stock_in_details.is_expiry_available == 'Y'
                      ? 'required'
                      : ''
                  "
                ></Datepicker>
                <label
                  :class="stock_in_details.stock_in_expiry_date ? 'active' : ''"
                  >{{ $t("stock") }} {{ $t("in") }} {{ $t("expiry") }}
                  {{ $t("date") }}</label
                >
              </div>
            </div>
            <Tooltip :title="$t('expirydate_updatestockin')" />
          </div>
          <p
            v-if="stock_in_details.is_expiry_available == 'Y'"
            class="error_message"
          >
            <span v-if="submitted && errors.has('expirydate')">{{
              errors.first("expirydate")
            }}</span>
          </p>
          <p v-else class="error_message">
            <span></span>
            <!-- <span v-if="submitted && errors.has('expirydate')">{{ errors.first('expirydate') }}</span> -->
          </p>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-validate="'required|alpha_num'"
                name="invoicenumber"
                id="invoicenumber"
                v-model="stock_in_details.invoice_number"
              />
              <label>{{ $t("invoice") }} {{ $t("number") }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('invoicenumber')">{{
              errors.first("invoicenumber")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="stock_in_details.invoice_date"
                  v-on:click="clearInvoiceDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="stock_in_details.invoice_date"
                  name="invoicedate"
                  id="invoicedate"
                  typeable
                  v-validate="'required'"
                  :disabled-dates="disabledDates"
                ></Datepicker>
                <label :class="stock_in_details.invoice_date ? 'active' : ''"
                  >{{ $t("invoice") }} {{ $t("date") }}</label
                >
              </div>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('invoicedate')">{{
              errors.first("invoicedate")
            }}</span>
          </p>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="number"
                name="extra_net"
                id="extra_net"
                v-model="stock_in_details.extra_charge_net"
              />
              <label>Net Extra Charge (Amt.)</label>
            </div>
          </div>
          <p class="error_message"></p>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="number"
                name="extra_net"
                id="extra_net"
                v-model="stock_in_details.extra_charge_tax"
              />
              <label>Extra Charge Tax (Amt.)</label>
            </div>
          </div>
          <p class="error_message"></p>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="number"
                name="extra_net"
                id="extra_net"
                :disabled="true"
                :value="
                  parseFloat(stock_in_details.extra_charge_net || 0) +
                  parseFloat(stock_in_details.extra_charge_tax || 0)
                "
              />
              <label>Total Extra Charge</label>
            </div>
          </div>
          <p class="error_message"></p>
        </div>

        <div class="col-md-12 text-center mt-2 mb-2">
          <button
            @click.prevent.stop="bulksavePurchaseOder()"
            :disabled="disableSubmit"
            class="btn-blue"
          >
            {{ $t("Save all") }}
          </button>

          <button
            v-if="is_stock_transfer_to_cinema"
            @click.prevent.stop="rejectAll()"
            :disabled="disableSubmit"
            class="btn-blue"
          >
            {{ $t("Reject All") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="stock-in">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
      <template v-if="stock_in_details_all && stock_in_details_all.length > 0">
        <!-- LIST VIEW -->
        <div class="">
          <table
            class="grn-report-table border mt-3"
            border="1"
            style="table-layout: fixed"
          >
            <thead>
              <tr class="lightBluebg">
                <th colspan="2">{{ $tc("rawmaterials", 2) }}</th>
                <th>{{ $t("Qty") }}</th>
                <th>{{ $t("Inward Qty") }}</th>
                <th>{{ $t("UOM") }}</th>
                <th colspan="1">{{ $t("batch") }} {{ $t("no.") }}</th>
                <th colspan="2">{{ $t("expiry") }} {{ $t("date") }}</th>
                <th colspan="2">Remarks</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(
                  purchaseOrder, purchaseOrderList
                ) in stock_in_details_all"
                :key="purchaseOrderList"
              >
                <td colspan="2" class="text-left">
                  {{ purchaseOrder.rm_name ? purchaseOrder.rm_name : "N/A" }}
                </td>
                <td>
                  {{ purchaseOrder.sum_stock_in_quantity }}
                </td>

                <td>
                  <input
                    v-model="purchaseOrder.stock_in_quantity"
                    @input="calculateNetAmount(purchaseOrder)"
                    style="border-radius: 5px"
                    class="w-100 form-control form-control-sm"
                    type="text"
                    step="any"
                    placeholder="Enter Qty."
                  />
                </td>

                <td>{{ purchaseOrder.uom_short_form }}</td>

                <td colspan="1">
                  <input
                    :disabled="is_stock_transfer_to_cinema"
                    v-model="purchaseOrder.batchNumber"
                    style="border-radius: 5px"
                    class="w-100 form-control form-control-sm borderNone"
                    type="number"
                    @input="
                      setBatchNumber($event, purchaseOrderList, purchaseOrder)
                    "
                  />
                </td>
                <td colspan="2">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <div class="add-datepicker">
                        <Datepicker
                          :monday-first="true"
                          ref="programaticOpen"
                          v-model="purchaseOrder.stock_in_expiry_date"
                          :name="`expiry_date_${purchaseOrderList}`"
                          :id="`expiry_date_${purchaseOrderList}`"
                          typeable
                          class="borderNone"
                          placeholder="Date"
                          :disabled-dates="disabledDates"
                        ></Datepicker>
                        <label
                          :class="
                            purchaseOrder.stock_in_expiry_date
                              ? 'd-none'
                              : 'lite-placeholder'
                          "
                          >Expiry Date</label
                        >
                      </div>
                    </div>
                    <div class="">&#x1F4C5;</div>
                  </div>
                </td>
                <td colspan="2">
                  <div class="input-material-textarea">
                    <textarea
                      rows="1"
                      class="borderNone"
                      v-model="purchaseOrder.grn_remark"
                    ></textarea>
                  </div>
                </td>
                <td
                  colspan="1"
                  class="px-0"
                  v-if="!is_stock_transfer_to_cinema"
                >
                  <button
                    :class="[
                      'btn btn-sm btn-primary mx-0 p-0 px-4 fs-12 py-1',
                      purchaseOrder.stock_in_quantity &&
                      purchaseOrder.stock_in_quantity >= 0
                        ? ''
                        : 'disabled',
                    ]"
                    :disabled="disableSubmit"
                    @click.prevent.stop="savePurchaseOder(purchaseOrder)"
                  >
                    {{ $t("Save") }}
                  </button>
                </td>
              </tr>

              <tr v-if="stock_in_details_all.length == 0">
                <td colspan="12">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService";
import MasterService from "@/services/MasterService";
import { encryptString } from "@/helper/collection"


export default {
  data() {
    return {
      submitted: false,
      disableSubmit: false,
      currentCinemaId:"",
      stock_in_details: {
        batch_number: null,
        invoice_number: null,
        invoice_date: null,
        extra_charge_net: 0,
        extra_charge_tax: 0,
        extra_charge_gross: 0,
      },
      disabledDates: {
        from: new Date(),
      },
      stock_in_details_copy: {},
      stock_in_id: "",
      po_id: "",
      rm_id: "",
      poi_qty: "",
      UomList: [],
      storeManagementsLevels: {},
      sigle_rate_net: 0,
      single_total_amount: 0,
      single_rate_tax: 0,

      stock_in_details_all: [],
      rm_ids: [],
      is_stock_transfer_to_cinema: false,
      random_batch_number: "",
    };
  },
  beforeMount() {
    this.stock_in_id = this.$route.query.stock_in_id;
    this.po_id = this.$route.query.po_id;
    this.rm_id = this.$route.query.rm_id;

    this.rm_ids =
      typeof this.$route.query.rm_ids == "string"
        ? [this.$route.query.rm_ids]
        : this.$route.query.rm_ids;
    this.random_batch_number = Math.floor(100000 + Math.random() * 900000);
    const {cinema_id=null}=this.$route.query
     if (!cinema_id) {
                  this.$toasted.show("Cinema is missing")
                  this.$router.push("/fnb/stock-in")
                }
                this.currentCinemaId = cinema_id
  },
  mounted() {
    this.stock_in_id = this.$route.query.stock_in_id;
    console.log({
      "this.stock_in_id": this.stock_in_id,
      "this.rm_id": this.rm_id,
      "this.rm_ids": this.rm_ids,
    });

    this.getStockInDetails();
    this.getUoM();

    this.getStockInDetailsForAll();
  },
  methods: {
    calculateNetAmount: function (item) {
      if (item.stock_in_quantity >= item.remaining_stock_in_quantity) {
        item.stock_in_quantity = item.remaining_stock_in_quantity;
      }

      if (item.poi_rate && item.stock_in_quantity) {
        item.poi_price = +parseFloat(
          item.poi_rate * item.stock_in_quantity
        ).toFixed(3);
      }

      if (item.poi_price && item.poi_tax_in_percentage) {
        item.poi_tax_amount = +parseFloat(
          ((item.poi_price - item.Discount) * item.poi_tax_in_percentage) / 100
        ).toFixed(3);
      }

      if (item.poi_price && item.poi_tax_amount) {
        item.poi_total_amount = +parseFloat(
          item.poi_price - item.Discount + item.poi_tax_amount
        ).toFixed(3);
      }
    },
    goToPOEdit: function () {
      this.$nextTick(() => {
        this.$router.push({
          path: "/fnb/edit-purchase-order",
          query: {
            po_number: this.stock_in_details.po_number,
            po_id: this.stock_in_details.po_id,
            fromBulkEdit: true,
            cinema_id:encryptString(String(this.currentCinemaId))
          },
        });
      });
    },
    clearInvoiceDate() {
      this.stock_in_details.invoice_date = "";
    },
    clearSelectedDate: function () {
      this.stock_in_details.stock_in_date = "";
    },
    clearSelectedDate1: function () {
      this.stock_in_details.stock_in_expiry_date = "";
    },
    getStockInDetails: function () {
      let payload = {
        // stock_in_id: this.stock_in_id || this.$route.query.stock_in_id,
        po_id: this.po_id || this.$route.query.po_id,
        rm_id: this.rm_id || this.$route.query.rm_id,
        cinema_id:this.currentCinemaId
      };
      PosFnbService.GetStockInDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.stock_in_details = data.Records[0];
            this.stock_in_details_copy = data.Records[0];
            this.getParentStore(
              data.Records[0].cinema_id || data.Records[0].cine_id
            );
            this.stock_in_details.stock_in_date === null
              ? (this.stock_in_details.stock_in_date = new Date())
              : this.stock_in_details.stock_in_date;
            this.GetUomForStockIn(this.stock_in_details);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
    getParentStore: function (cinema_id) {
      let payload = {
        tableName: "store_management",
        sm_is_active: "Y",
        cinema_id: cinema_id,
        sm_parent_id: 0,
        sm_order: 1,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.storeManagementsLevels = data.Records[0];
          } else if (data.Records.length == 0) {
            this.$toasted.show(
              "Please create one main store to transfer stock into"
            );
            setTimeout(() => {
              this.$router.go(-1);
            }, 100);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    GetUomForStockIn: function (stock_in_details) {
      let payload = {
        rm_id: stock_in_details.rm_id,
        po_id: stock_in_details.po_id,
        cinema_id:this.currentCinemaId
      };
      PosFnbService.GetUomForStockIn(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.stock_in_details["uom_id"] = data.Records[0].uom_id;
              this.stock_in_details["uom_unit"] =
                data.Records[0].uom_short_form;
              this.poi_qty = this.stock_in_details.sum_stock_in_quantity;
              this.stock_in_details.stock_in_quantity =
                this.stock_in_details.sum_stock_in_quantity;
              console.log("this.stock_in_details :>> ", this.stock_in_details);
              this.sigle_rate_net = +parseFloat(
                this.stock_in_details["poi_price"] /
                  this.stock_in_details["poi_qty"]
              ).toFixed(3);
              this.single_rate_tax = +parseFloat(
                this.stock_in_details["poi_tax_amount"] /
                  this.stock_in_details["poi_qty"]
              ).toFixed(3);
              this.single_total_amount = +parseFloat(
                this.stock_in_details["poi_total_amount"] /
                  this.stock_in_details["poi_qty"]
              ).toFixed(3);
              this.CalculateSelectedRawMaterial(
                this.stock_in_details.stock_in_quantity
              );
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
    getUoM: function () {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.UomList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectQty: function (qty) {
      this.stock_in_details["stock_in_quantity"] = qty;
    },
    onSelectUnitOfM: function (params) {
      this.stock_in_details["uom_id"] = params.uom_id;
      this.stock_in_details["uom_unit"] = params.uom_unit;
    },
    CalculateSelectedRawMaterial: function (params) {
      if (this.poi_qty && params > this.poi_qty) {
        this.stock_in_details["stock_in_quantity"] = this.poi_qty;
        this.$toasted.show("Max quantity is " + this.poi_qty);
      } else {
        this.stock_in_details["stock_in_quantity"] = params;
      }

      console.log(
        this.sigle_rate_net,
        this.single_rate_tax,
        this.single_total_amount
      );
      this.stock_in_details["poi_price"] =
        this.sigle_rate_net * this.stock_in_details["stock_in_quantity"];
      this.stock_in_details["poi_tax_amount"] =
        this.single_rate_tax * this.stock_in_details["stock_in_quantity"];
      this.stock_in_details["poi_total_amount"] =
        this.single_total_amount * this.stock_in_details["stock_in_quantity"];

      console.log(this.stock_in_details);
    },
    resetForm: function () {
      this.stock_in_details = {};
    },
    OnFinalSubmit: function () {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :>> ", valid);
        if (valid) {
          console.log(
            "this.stock_in_details.stock_in_quantity :>> ",
            this.stock_in_details.stock_in_quantity
          );
          if (this.stock_in_details.stock_in_quantity > 0) {
            this.disableSubmit = true;
            let payload = {
              ...this.stock_in_details,
              stock_in_id: this.stock_in_id,
              sm_id: this.storeManagementsLevels.sm_id,
              poi_qty: this.poi_qty,
              cinema_id:this.currentCinemaId
            };
            PosFnbService.updatStockinDetails(payload)
              .then((response) => {
                const { data } = response;
                this.disableSubmit = false;
                if (data && data.status) {
                  this.$toasted.show(data.message);
                  this.$router
                    .push({
                      path: "stock-in",
                    })
                    .catch((err) => {
                      console.log("err :>> ", err);
                    });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch((err) => {
                this.disableSubmit = false;
                this._CatchError;
              }); //message
          } else {
            this.disableSubmit = false;
            this.$toasted.show("Stock In Quantity cannot be 0");
          }
        }
      });
    },

    getStockInDetailsForAll: function () {
      console.log({ rm_ids: this.rm_ids });

      let promises = ([...new Set(this.rm_ids)] || []).map((rm) => {
        let payload = {
          stock_in_id: this.stock_in_id,
          po_id: this.po_id,
          rm_id: rm,
          cinema_id:this.currentCinemaId
        };

        console.log({ rm, payload });

        return PosFnbService.GetStockInDetails(payload).then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {

            const uniquePoItems = [
              ...new Map(data.Records.map(item => [item.poi_id, item])).values()
            ];

            return uniquePoItems.map((itemObj) => {
              let stock_in_details = {...itemObj};
            // this.getParentStore(data.Records[0].cinema_id);

              stock_in_details.stock_in_date === null
                ? (stock_in_details.stock_in_date = new Date())
                : stock_in_details.stock_in_date;
              // this.GetUomForStockIn(stock_in_details);

              stock_in_details.stock_in_quantity = 0; // stock_in_details.sum_stock_in_quantity;
              stock_in_details.sigle_rate_net = +parseFloat(
                stock_in_details["poi_price"] / stock_in_details["poi_qty"]
              ).toFixed(3);
              stock_in_details.single_rate_tax = +parseFloat(
                stock_in_details["poi_tax_amount"] / stock_in_details["poi_qty"]
              ).toFixed(3);
              stock_in_details.single_total_amount = +parseFloat(
                stock_in_details["poi_total_amount"] / stock_in_details["poi_qty"]
              ).toFixed(3);

              stock_in_details.poi_price_init = 0;
              stock_in_details.poi_tax_amount_init = 0;
              stock_in_details.poi_total_amount_init = 0;

              console.log(
                "stock_in_details.sigle_rate_net",
                stock_in_details.sigle_rate_net,
                "\n",
                "stock_in_details.single_rate_tax",
                stock_in_details.single_rate_tax,
                "\n",
                "stock_in_details.single_total_amount",
                stock_in_details.single_total_amount,
                "\n",
                'stock_in_details["poi_price"]',
                stock_in_details["poi_price"],
                "\n"
              );

              return stock_in_details;
            })

            // let stock_in_details = data.Records[0];
            // // this.getParentStore(data.Records[0].cinema_id);

            // stock_in_details.stock_in_date === null
            //   ? (stock_in_details.stock_in_date = new Date())
            //   : stock_in_details.stock_in_date;
            // // this.GetUomForStockIn(stock_in_details);

            // stock_in_details.stock_in_quantity = 0; // stock_in_details.sum_stock_in_quantity;
            // stock_in_details.sigle_rate_net = +parseFloat(
            //   stock_in_details["poi_price"] / stock_in_details["poi_qty"]
            // ).toFixed(3);
            // stock_in_details.single_rate_tax = +parseFloat(
            //   stock_in_details["poi_tax_amount"] / stock_in_details["poi_qty"]
            // ).toFixed(3);
            // stock_in_details.single_total_amount = +parseFloat(
            //   stock_in_details["poi_total_amount"] / stock_in_details["poi_qty"]
            // ).toFixed(3);

            // stock_in_details.poi_price_init = 0;
            // stock_in_details.poi_tax_amount_init = 0;
            // stock_in_details.poi_total_amount_init = 0;

            // console.log(
            //   "stock_in_details.sigle_rate_net",
            //   stock_in_details.sigle_rate_net,
            //   "\n",
            //   "stock_in_details.single_rate_tax",
            //   stock_in_details.single_rate_tax,
            //   "\n",
            //   "stock_in_details.single_total_amount",
            //   stock_in_details.single_total_amount,
            //   "\n",
            //   'stock_in_details["poi_price"]',
            //   stock_in_details["poi_price"],
            //   "\n"
            // );

            // return stock_in_details;
          } else {
            this.$toasted.show(data.message);
            return null;
          }
        });
      });

      Promise.all(promises)
        .then((getStockInDetailsAllRes) => {
          console.log({ getStockInDetailsAllRes });

          this.stock_in_details_all =
            getStockInDetailsAllRes.flat().filter((x) => !!x) || [];

          this.stock_in_details_all.map((z) => {
            z["Discount"] = 0;
            z["stock_in_quantity"] = z.remaining_stock_in_quantity;
            this.calculateNetAmount(z);
          });

          if (
            this.stock_in_details_all.length &&
            this.stock_in_details_all[0].transfer_stock_id
          ) {
            this.is_stock_transfer_to_cinema = true;

            this.$nextTick(() => {
              this.$nextTick(() => {
                this.stock_in_details_all.forEach((p, i) => {
                  this.setBatchNumber(
                    {
                      target: {
                        value: this.random_batch_number,
                      },
                    },
                    i,
                    p
                  );
                }, 100);
              });
            });
          }

          this.$forceUpdate();
        })
        .catch((err) => {
          this.stock_in_details_all = [];
          this.$toasted.show(err);
        });
    },
    setQuantityInward(event, index, purchaseOrder) {
      let value = event.target.value;

      if (purchaseOrder.sum_stock_in_quantity < value) {
        this.$toasted.show(
          "Max quantity is " + purchaseOrder.sum_stock_in_quantity
        );
        value = purchaseOrder.sum_stock_in_quantity;
        this.$forceUpdate();
      }

      let UOMID = purchaseOrder.uom_id;
      console.log(UOMID);
      console.log(UOMID, this.UomList, purchaseOrder);
      let [UOM] = this.UomList.filter((x) => x.uom_id == UOMID);

      let conversionFormula = UOM ? UOM.conversion_formula || 1 : 1;
      let convertedValue = value * conversionFormula;

      purchaseOrder.stock_in_quantity = convertedValue;
      purchaseOrder.poi_price_init =
        purchaseOrder.sigle_rate_net * purchaseOrder.stock_in_quantity;
      purchaseOrder.poi_tax_amount_init =
        purchaseOrder.single_rate_tax * purchaseOrder.stock_in_quantity;
      purchaseOrder.poi_total_amount_init =
        purchaseOrder.single_total_amount * purchaseOrder.stock_in_quantity;

      this.$forceUpdate();
    },
    setBatchNumber(event, index, purchaseOrder) {
      let value = event.target.value;

      purchaseOrder.batchNumber = value;

      this.$forceUpdate();
    },
    savePurchaseOder(purchaseOrder) {
      this.bulksavePurchaseOder([purchaseOrder]);
      this.$forceUpdate();
    },
    rejectAll() {
      let purchaseOrders = this.stock_in_details_all;

      MasterService.RejectToCinemaStockTransferByPo(purchaseOrders[0].po_id,this.currentCinemaId)
        .then((res) => {
          const { data } = res;
          this.disableSubmit = false;
          if (data && data.status) {
            this.$toasted.show(data.message);
            this.$router
              .push({
                path: "stock-in",
              })
              .catch((err) => {
                console.log("err :>> ", err);
              });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((e) => {
          console.log({ e });
          this.$toasted.show(e.message);
        })
        .finally(() => {
          this.$forceUpdate();
        });
    },
    bulksavePurchaseOder(purchaseOrders) {
      this.submitted = true;
      this.disableSubmit = true;
      if (!purchaseOrders) purchaseOrders = this.stock_in_details_all;

      this.$validator.validate().then((valid) => {
        console.log({ valid });

        if (valid) {
          let stocks = purchaseOrders.filter((x) => {
            return x.stock_in_quantity > 0;
          });
          if (stocks.length === 0) {
            this.disableSubmit = false;
            console.log("nothing to submit");
            this.$toasted.show("Inward quantity must be greater than 0");
            return;
          }

          let loader = this.$loading.show();

          let payloadArray = [];
          stocks.map((x) => {
            x["extra_charge_net"] = 0;
            x["extra_charge_tax"] = 0;
            x["extra_charge_gross"] = 0;
            let payload = {
              ...x,
              stock_in_id: this.stock_in_id,
              sm_id: this.storeManagementsLevels.sm_id,
              poi_qty: x.stock_in_quantity,
              // stock_in_expiry_date: this.stock_in_details.stock_in_expiry_date,
              invoice_number: this.stock_in_details.invoice_number,
              invoice_date: this.stock_in_details.invoice_date,
              extra_charge_net: parseFloat(
                this.stock_in_details.extra_charge_net || 0
              ),
              extra_charge_tax: parseFloat(
                this.stock_in_details.extra_charge_tax || 0
              ),
              extra_charge_gross:
                parseFloat(this.stock_in_details.extra_charge_net || 0) +
                parseFloat(this.stock_in_details.extra_charge_tax || 0),
            };
            payloadArray.push(payload);
          });
          PosFnbService.updatStockinDetailsV2(payloadArray,this.currentCinemaId)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(data.message);
                this.$router
                  .push({
                    path: "stock-in",
                  })
                  .catch((err) => {
                    console.log("err :>> ", err);
                  });
              }
            })
            .catch((e) => {
              console.log({ e });
              this.$toasted.show(e.message);
            })
            .finally(() => {
              this.disableSubmit = false;
              loader.hide();
              this.$forceUpdate();
            });
        } else {
          this.disableSubmit = false;
        }
      });
    },
  },
};
</script>

<style>
.borderNone {
  border: none !important;
}
.borderBottom {
  border-bottom: 1px solid !important;
}
.grn-report-table td {
  padding: 0px 10px 0px 10px;
  white-space: normal !important;
}
.grn-report-table th {
  padding: 5px 8px 5px 15px;
}
.grn-report-table {
  width: 100%;
  color: var(--text);
  text-align: center;
  table-layout: fixed;
  border: 1px solid #787878;
}
.borderNone input {
  border: none !important;
}

.lite-placeholder {
  font-size: 12px !important;
  font-weight: 300 !important;
  color: darkgrey !important;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/StockComponents/bulkUpdateStockIn.vue